module.exports = __webpack_public_path__ + "static/media/Illus-Empty_1@2x.7d06ff08.png";